import { Alert } from 'truper-web-react-components';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from './hooks/reduxHooks';

import Header from './components/Header';
import Home from './views/Home';
import Formulario from './views/Formulario';
import Notificacion from './views/Notificacion';
import Login from './views/Login';
import Bandeja from './views/Bandeja';
import AuthScreen from './views/AuthScreen';
import ScreenLoader from './components/atoms/ScreenLoader';
import { hideAlert } from './redux/global/globalSlice';

import './styles/App.css';
import { LineamientosScreen } from './views/LineamientosScreen';
import { DenunciaScreen } from './views/DenunciaScreen';
import { ConsultaDenunciaScreen } from './views/ConsultaDenunciaScreen';
import { FaqScreen } from './views/FaqScreen';
import { ShouldShowHeader } from './components/atoms/ShouldShowHeader';
import AnaliticasScreen from './views/AnaliticasScreen';

const BASENAME_OPTIONS = {
  fixtescucha: '/fix-tescucha',
  tescucha: '/tescucha',
};

const normalizeRoles = roles =>
  Array.isArray(roles) ? roles.map(role => String(role || '').toUpperCase().trim()) : [];

const hasAdminAccess = user => {
  if (!user) return false;
  const roles = user?.userData?.roles || [];
  const normalizedRoles = normalizeRoles(roles);
  const hasConfigRole = normalizedRoles.some(role => role === 'CONFIG' || role.includes('CONFIG'));
  const hasAdminRole = normalizedRoles.some(
    role =>
      role === 'ADMIN' ||
      role === 'ADMIN_DENUNCIAS' ||
      role.includes('ADMIN') ||
      role.includes('ADMIN_DENUNCIAS')
  );
  return hasAdminRole && !hasConfigRole;
};

const App = () => {
  const location = useLocation();
  // Hooks
  const dispatch = useAppDispatch();
  // Detectar el dominio actual
  const basename = window.location.pathname.includes('fix-tescucha')
    ? BASENAME_OPTIONS.fixtescucha
    : BASENAME_OPTIONS.tescucha;
  const { alert, loader } = useAppSelector(({ globalReducer }) => globalReducer);
  const { loginData } = useAppSelector(({ adminReducer }) => adminReducer);
  const isAdminUser = hasAdminAccess(loginData.user);

  const [shouldShowHeader, setShouldShowHeader] = useState(false);

  useEffect(() => {
    let title = 'TEscucha: Sistema de Denuncias';
    const basename = location.pathname.split('/')[1]; // Obtener el basename del URL

    if (basename === 'fix-tescucha') {
      title = 'FIX TEscucha: Sistema de Denuncias';
    }
    document.title = title;
  }, [location]);

  return (
    <>
      <Helmet>
        <title>{document.title}</title>
      </Helmet>
      <Router basename={basename}>
        <div className="App">
          <ScreenLoader loading={loader} />
          {shouldShowHeader && <Header basename={basename} />}
          <div className={shouldShowHeader ? 'shouldShowHeader' : ''}>
            <Switch>
              <Route path="/" exact render={() => <Redirect to="/home/colaborador" />} />
              <Route path="/auth" component={AuthScreen} />
              <Route path="/acceso/login" component={Login} />
              <Route path="/home/:perfil(proveedor|colaborador)" component={Home} />
              <Route path="/viewForm/:perfil(proveedor|colaborador)/:idEstatus([0-9]{1})" component={Formulario} />
              <Route
                path="/bandeja/:perfil(proveedor|colaborador)"
                render={props => (isAdminUser ? <Bandeja {...props} /> : <Redirect to="/home/colaborador" />)}
              />
              <Route
                path="/analiticas"
                render={props => (isAdminUser ? <AnaliticasScreen {...props} /> : <Redirect to="/home/colaborador" />)}
              />
              <Route path="/notificacion/:perfil(proveedor|colaborador)" component={Notificacion} />
              <Route path="/lineamientos" component={LineamientosScreen} />
              <Route path="/preguntas-frecuentes" component={FaqScreen} />
              <Route path="/denuncia" exact component={DenunciaScreen} />
              <Route path="/denuncia/consulta" exact component={ConsultaDenunciaScreen} />
            </Switch>
          </div>
          <div className="material-alert">
            <Alert
              show={alert.visibility}
              type={alert.type}
              message={alert.message}
              onCloseClick={() => hideAlert(dispatch)}
            />
          </div>
        </div>
        <ShouldShowHeader setShouldShowHeader={setShouldShowHeader} />
      </Router>
    </>
  );
};

export default App;
